"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _index = require("../Icons/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Alert = function Alert(_ref) {
  var children = _ref.children,
      type = _ref.type,
      onClick = _ref.onClick,
      icon = _ref.icon,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "type", "onClick", "icon", "className"]);

  return /*#__PURE__*/_react.default.createElement(AlertBox, _extends({
    type: type,
    onClick: onClick,
    className: className
  }, otherProps), icon ? type === 'error' ? /*#__PURE__*/_react.default.createElement(ErrorIcon, {
    color: '#F74040',
    size: 40
  }) : /*#__PURE__*/_react.default.createElement(DefaultIcon, {
    type: type ? type : 'normal'
  }, "i") : '', /*#__PURE__*/_react.default.createElement(ContentWrapper, {
    type: type
  }, children));
};

var AlertBox = _styledComponents.default.div.withConfig({
  displayName: "AlertBox"
})(["display:flex;justify-content:flex-start;align-items:flex-start;width:100%;max-width:100rem;padding:", ";border:1px solid ", ";border-radius:5px;background:", ";"], function (_ref2) {
  var type = _ref2.type;
  return type ? '2.4rem' : '0';
}, function (_ref3) {
  var type = _ref3.type,
      theme = _ref3.theme;
  return getTypeColor(type, theme);
}, function (_ref4) {
  var type = _ref4.type,
      theme = _ref4.theme;
  return getLighterColor(type, theme);
});

var DefaultIcon = _styledComponents.default.div.withConfig({
  displayName: "DefaultIcon"
})(["width:2rem;height:2rem;flex:0 0 2rem;border-radius:999px;display:flex;justify-content:center;align-items:center;border:1.5px solid ", ";color:", ";font-family:'Times New Roman',sans-serif;font-style:italic;font-weight:bold;font-size:1.2rem;line-height:1.4rem;margin-right:1rem;"], function (_ref5) {
  var type = _ref5.type,
      theme = _ref5.theme;
  return getTypeColor(type, theme);
}, function (_ref6) {
  var type = _ref6.type,
      theme = _ref6.theme;
  return getTypeColor(type, theme);
});

var ErrorIcon = (0, _styledComponents.default)(_index.IconActionClose).withConfig({
  displayName: "ErrorIcon"
})(["margin-right:1rem;width:3rem;height:3rem;flex:0 0 3rem;"]);

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "ContentWrapper"
})(["margin:auto 0;padding-top:3px;font-family:", ";font-size:1.2rem;line-height:1.5rem;color:", ";h1,h2,h3,h4,h5,h6,p{font-family:", ";font-style:normal;font-weight:normal;font-size:1.2rem;line-height:1.5rem;color:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.font;
}, function (_ref8) {
  var type = _ref8.type,
      theme = _ref8.theme;
  return getTextColor(type, theme);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.font;
}, function (_ref10) {
  var type = _ref10.type,
      theme = _ref10.theme;
  return getTextColor(type, theme);
});

var getTypeColor = function getTypeColor(type, theme) {
  switch (type) {
    case 'primary':
      return theme.brand.primary;

    case 'error':
      return theme.status.error;

    case 'warning':
      return theme.status.warning;

    case 'success':
      return theme.status.succes;

    case 'normal':
      return '#8990A3';

    default:
      return 'transparent';
  }
};

var getTextColor = function getTextColor(type, theme) {
  switch (type) {
    case 'primary':
      return theme.brand.primary;

    case 'error':
      return theme.status.error;

    case 'warning':
      return theme.status.warning;

    case 'success':
      return theme.status.succes;

    case 'normal':
      return '#8990A3';

    default:
      return '#8990A3';
  }
};

var getLighterColor = function getLighterColor(type, theme) {
  switch (type) {
    case 'primary':
      return theme.brand.lightest;

    case 'error':
      return theme.status.errorLight;

    case 'warning':
      return theme.status.warningLight;

    case 'success':
      return theme.status.succesLight;

    case 'normal':
      return '#F6F6F6';

    default:
      return 'transparent';
  }
};

Alert.propTypes = {
  /** Content to be shown inside the alert box. */
  children: _propTypes.node.isRequired,

  /** The type of alert box to be shown. (normal, primary, error, warning, success OR do not pass a value for the default styling) */
  type: _propTypes.string,

  /** Optional onClick function which gets triggered by clicking the whole box. */
  onClick: _propTypes.func,

  /** Wether or not to show the default "info" icon. */
  icon: _propTypes.bool,

  /** Optional className to be applied. */
  className: _propTypes.string,

  /** Optional props to be passed. */
  otherProps: _propTypes.object
};
var _default = Alert;
exports.default = _default;